<!--
=========================================================
* Vue Material Dashboard 2 PRO - v3.1.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-material-dashboard-2-pro
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <main
    class="main-content position-relative max-height-vh-100 h-100 overflow-x-hidden"
  >
    <router-view />
    <div class="footer px-4">Copyright &copy; <a href="https://senceive.com">Senceive Ltd</a> 2024. For internal users only.</div>
  </main>
</template>
<script>
export default {
  name: "App",
};
</script>
<style>
.dataTable-pagination-list .active a {
  background-image: linear-gradient(
    195deg,
    #66bb6a 0%,
    #43a047 100%
  ) !important;
}
</style>
